module.exports = __webpack_public_path__ + "static/media/slidePicture1.3d9de4be.jpg";